import React from 'react';
import { components } from 'react-select';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
export { ClearIndicator, DropdownIndicator, LoadingIndicator } from './indicators';
export var MultiValueRemove = function MultiValueRemove(props) {
  return /*#__PURE__*/React.createElement(components.MultiValueRemove, props, /*#__PURE__*/React.createElement(SelectClearIcon, {
    label: "Clear",
    size: "small",
    primaryColor: "transparent",
    secondaryColor: "inherit"
  }));
};
export var IndicatorSeparator = null;